<template>
        <div v-if="relativeUsers &&  relativeUsers.length>0">
        <div class="check-box-div">
              <i class="fa fa-fw fa-check-square-o" @click="setUseRelativeUser(false)" v-if="useRelativeUser === true"></i>
              <i class="fa fa-fw fa-square-o" @click="setUseRelativeUser(true)" v-else></i>
              {{'BuyCscForRelativeUser' | lang}}
          </div>        
        
        

            <div v-if="useRelativeUser" >
                        <div class="floating-label">
                            <select v-model="userCode" placeholder=" " type="text">
                            <option v-for="(t, tidx) in relativeUsers" :value="t.UserCode" :key="tidx">{{t.LastName +" "+ t.FirstName}}</option>
                           </select>
                            <label>{{ "RelativeUser" | lang }}:</label>
                        </div>
            </div>
            
        </div>    
</template>

<script>

import UserServices from '@/mixins/services/userServices'
export default {
    name: 'SelectUser',
    mixins: [UserServices],
    props: ['usercode'],
    computed: {
        
    },
    data() {
        return {
            relativeUsers: [],
            useRelativeUser:false,
            userCode:""
        }
    },
    mounted() {
        this.userCode=this.user.UserAccountCode;
        this.updateData()
    },
    methods: {
    setUseRelativeUser(use){
      this.useRelativeUser=use;
      if(!use)
      {
        this.userCode=this.user.UserAccountCode
      }
      else
      {
        this.userCode="";
      }
    },
        updateData() {
            this.loading = true
            this._getRelativeUsers().then(data => {
                this.relativeUsers = data.filter(function (el) {
                                        return !el.IsAvailableLinkUpdateable
                                    }
                                    );
            }).catch(err => {
               
            })
        }  
    },

    watch: {
        'userCode': {
      handler(val) {
        this.$emit('update:usercode', val)
      }
    }
}
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#app.desktop .selectusers {
    max-height: 30rem;
    margin-top: .5rem;
}

#app.mobile .selectusers {
    height: 100%;
}

.check-box-div
{
    margin: 0.9rem 0;
    position: relative;
}
</style>
